var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "dna_1_"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "investment"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "company"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "square-meter"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "bios-generics"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "professional"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "capacity"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "award"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "pills"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "neutral_19_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.1,315.2v-22.1h44.2c0,0,0-132.6,0-165.8c0-54.9-44.5-99.5-99.5-99.5c-16,0-30.8,4.1-44.2,10.8 c-13.4-6.7-28.2-10.8-44.2-10.8c-20.8,0-40.1,6.4-56.1,17.4c-19.3-11-41.7-17.4-65.5-17.4c-73.2,0-132.6,59.4-132.6,132.6v309.5 h198.9v-44.2h66.3h44.2h11.1c42.6,0,44.2,39.7,44.2,44.2H415c0-22.9-13.9-66.3-66.3-66.3h-11.1v-44.2h44.2c0,0,0-1.8,0-4.4 c0-3.7,0-9.7,0-17.7h44.2c31.2,0,33.1,27.7,33.2,33.2v85.1v14.4h22.1v-99.5C481.4,351.3,469.8,315.2,426.1,315.2z M271.3,337.3 v66.3h-44.2h-11.1H205v22.1v22.1H50.3V160.4c0-60.9,49.6-110.5,110.5-110.5c60.9,0,110.5,49.6,110.5,110.5v11.1h-22.1 c-9.8,0-16.9,3.3-22.1,7.9c-6.7-5.6-15.2-7.9-22.1-7.9h-44.2c-18.1,0-27.6,11-31.3,22.1h-35c-24.3,0-33.2,19.8-33.2,33.2v22.1 c0,6.1,4.9,11.1,11.1,11.1c6.1,0,11.1-4.9,11.1-11.1v-7.4v-14.6c0.1-5.1,2.2-11.2,11.1-11.2h27.6h5.5v11.1 c0,24.3,19.8,33.2,33.2,33.2H205c9.8,0,16.9-3.3,22.1-7.9c6.7,5.6,15.2,7.9,22.1,7.9h22.1V337.3z M282.4,226.6 c-0.1,5.1-2.2,11.2-11.1,11.2h-22c-5.1-0.1-11.2-2.2-11.2-11.1v-22c0.1-5.1,2.2-11.2,11.1-11.2h22c5.1,0.1,11.2,2.2,11.2,11.1 V226.6z M149.8,204.8c0.1-5.1,2.2-11.2,11.1-11.2h44.1c5.1,0.1,11.2,2.2,11.2,11.1v22c-0.1,5.1-2.2,11.2-11.1,11.2H161 c-5.1-0.1-11.2-2.2-11.2-11.1V204.8z M359.8,315.2v22.1h-22.1h-22.1v22.1v44.2h-22.1c0-20.6,0-53.3,0-88.4V252 c7.8-7,11.1-17.2,11.1-25.2v-22.1c0-11.8-4.7-19.9-11.1-25.2v-19c0-40.6-18.3-76.9-47-101.2c10.8-5.7,22.9-9.3,36-9.3 c42.7,0,77.4,34.7,77.4,77.4V315.2z M404,271v22.1v22.1h-22.1c0-60.6,0-164.7,0-187.9c0-29.4-13-55.5-33.2-73.7 c7.1-2.1,14.4-3.6,22.2-3.6c42.7,0,77.4,34.7,77.4,77.4V271h-22.1H404z"
  })))));
}

export default SvgAlvotechPeople;